import StringInput from './StringInput';
import { _eval } from '../utils';

function DateInput(props) {


    const handleChange = (sid, obj) => {

        // Check if string match the date pattern
        if ((() => {
            const re = new RegExp('[0-9]{4}-[0-9]{2}-[0-9]{2}');
            return re.test(obj.value)
        })()) {
            try {
                let date = new Date(obj.value);
                obj.value = date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }).replaceAll('/', '-');
            } catch (e) {
                console.error('Date format is not valid')
            }
        }

        // If we must keep the label in the value,
        // concat the label with the value
        if (_eval(props, 'data', 'keepLabel'))
            if (props.data.keepLabel === true)
                obj.value = props.data.label + ' -> ' + obj.value

        props.handleChange(sid, obj)

    }
    return (
        <StringInput
            data={props.data}
            handleChange={handleChange}
            formData={props.formData}
        />
    );
}

export default DateInput;